import { Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useSetPasswordMutation } from "store/auth/auth.api";
import * as Yup from "yup";

const ResetPasswordForm = ({ email }) => {
  const [setPassword, { isLoading }] = useSetPasswordMutation();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: email,

      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Email invalide").required("Requis"),
      password: Yup.string()
        .min(6, "Minimum 6 caractères")
        .required("Mot de passe requis"),
      confirmPassword: Yup.string()
        .oneOf(
          [Yup.ref("password"), null],
          "Les mots de passe ne correspondent pas"
        )
        .required("Confirmation du mot de passe requise"),
    }),
    onSubmit: async (values, formikHelpers) => {
      const { setSubmitting, setStatus } = formikHelpers;
      const { email, password } = values;
      try {
        const response = await setPassword({ email, password }).unwrap();
        setStatus({ success: true, message: response.message });
        navigate("/login");
      } catch (error) {
        setStatus({
          success: false,
          message: error?.data?.message || "Erreur",
        });
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Grid container justifyContent="center" alignItems="center" mt={4}>
      <Paper elevation={3} sx={{ padding: 4, width: 400 }}>
        <Typography variant="h5" gutterBottom>
          Réinitialiser le mot de passe
        </Typography>
        <form onSubmit={formik.handleSubmit}>
          <TextField
            fullWidth
            id="email"
            name="email"
            label="Adresse e-mail"
            margin="normal"
            value={email}
            disabled
          />

          <TextField
            fullWidth
            id="password"
            name="password"
            label="Nouveau mot de passe"
            type="password"
            margin="normal"
            value={formik.values.password}
            onChange={formik.handleChange}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
          />
          <TextField
            fullWidth
            id="confirmPassword"
            name="confirmPassword"
            label="Confirmer le mot de passe"
            type="password"
            margin="normal"
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            error={
              formik.touched.confirmPassword &&
              Boolean(formik.errors.confirmPassword)
            }
            helperText={
              formik.touched.confirmPassword && formik.errors.confirmPassword
            }
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={formik.isSubmitting || isLoading}
            sx={{ mt: 2 }}>
            Réinitialiser
          </Button>
          {formik.status && (
            <Typography
              variant="body2"
              color={formik.status.success ? "green" : "error"}
              mt={2}>
              {formik.status.message}
            </Typography>
          )}
        </form>
      </Paper>
    </Grid>
  );
};

export default ResetPasswordForm;
